import { render, staticRenderFns } from "./activateUserAccount.vue?vue&type=template&id=3a85083a&"
import script from "./activateUserAccount.vue?vue&type=script&lang=js&"
export * from "./activateUserAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports